import { TopicPackSku } from "@/types";
import covid19 from "./covid19";
import nsfwVol1 from "./nsfwVol1";
import usPoliticsVol1 from "./usPoliticsVol1";
import initial from "./initial";

export default class Packs {
  _indexes: number[];
  packs: string[][];

  constructor(unlockedPacks: TopicPackSku[], ignoredPacks: TopicPackSku[] = []) {
    this.packs = Array.from(initial.topics);
    this._indexes = [];
    this.buildPacks(unlockedPacks, ignoredPacks);
  }

  static get packList() {
    const list = {
      covid19,
      nsfwVol1,
      usPoliticsVol1,
    };
    return list;
  }

  buildPacks(unlockedPacks: TopicPackSku[], ignoredPacks: TopicPackSku[]) {
    if (!ignoredPacks.includes(covid19.sku))
      covid19.topics.forEach((t: string[]) => this.packs.push(t));
    if (!ignoredPacks.includes(nsfwVol1.sku))
      nsfwVol1.topics.forEach((t: string[]) => this.packs.push(t));
    if (!ignoredPacks.includes(usPoliticsVol1.sku))
      usPoliticsVol1.topics.forEach((t: string[]) => this.packs.push(t));
  }

  pluck(count: number): string[] {
    const res = [];
    for (let i = 0; i < count; i++) res.push(this.findTopic());
    this._indexes = [];
    return res;
  }

  findTopic(): string {
    const packIndex = this.findIndex(this.packs.length);
    const pack = this.packs[packIndex];
    return pack[Math.floor(Math.random() * pack.length)];
  }

  findIndex(length: number): number {
    const index = Math.floor(Math.random() * length);
    if (this._indexes.includes(index)) return this.findIndex(length);
    this._indexes.push(index);
    return index;
  }
}
